import ImageWithPlaceholder from "../../components/ImageWithPlaceholder"
import { truncateStringWithEllipsis } from "../../utils/stringUtils"

const ServiceProviderDetails = ({
    imageUrl="",
    name="",
    details=""
}) => {
    return (
        <div className="display-flex flex-direction-row align-items-center width-100pct">
            <div className={`margin-bottom-5px`}>
                <ImageWithPlaceholder src={imageUrl} containerClassName="productImageContainer"/>
            </div> 
            <div className="margin-left-20px max-width-100pct overflow-hidden">
                <div className="
                    overflow-hidden text-overflow-ellipsis max-width-100pct width-fit-content 
                    font-size-16px font-weight-600 color-dark-grey"
                >
                    {truncateStringWithEllipsis(name, 35)}
                </div>
                <div className="font-size-14px">{details}</div>
            </div>
        </div>
    )
}

export default ServiceProviderDetails